import store from '../../store/store';

let firstNavigation = true;
let firstGameNavigation = true;

export const registerFirstNavigation = () => {
  firstNavigation = false;
};

export const getDefaultPathObject = () => {
  const { demo, hasAuthToken } = store.getters;
  if (demo) return ({ path: '/demo' });
  if (!hasAuthToken) return { path: '/signin', replace: true };
  return { path: '/' };
};

export const loggedIn = (to, from, next) => {
  if (!store.getters.hasAuthToken) return next({ path: '/signin', replace: true });
  next();
};

export const loggedInAndNotProlidUser = (to, from, next) => {
  if (!store.getters.hasAuthToken) return next({ path: '/signin', replace: true });

  // If there is no @ in the user's email, then they are a PROLID user
  if (!store.getters.me || !store.getters.me.email || !store.getters.me.email.includes('@')) return next({ path: '/', replace: true });

  next();
};

export const canManageGames = (to, from, next) => {
  if (store.getters.canManageGames) return next();
  next(getDefaultPathObject());
};

export const canManageClasses = (to, from, next) => {
  if (store.getters.canManageClasses) return next();
  next(getDefaultPathObject());
};

export const canManageDashboards = (to, from, next) => {
  if (store.getters.canManageDashboards) return next();
  next(getDefaultPathObject());
};

export const canEditGameGeneralSettings = (to, from, next) => {
  if (store.getters.canEditGameGeneralSettings) return next();
  next(getDefaultPathObject());
};

export const canManageGameSets = (to, from, next) => {
  if (store.getters.canManageGameSets) return next();
  next(getDefaultPathObject());
};

export const canManageGameInvites = (to, from, next) => {
  if (store.getters.canManageGameInvites) return next();
  next(getDefaultPathObject());
};

export const canManageEnvironments = (to, from, next) => {
  if (store.getters.canManageEnvironments) return next();
  next(getDefaultPathObject());
};

export const canOpenGameListAndGameEdit = (to, from, next) => {
  if (store.getters.canManageGameInvites
    || store.getters.canEditGameGeneralSettings
    || store.getters.canManageGames) {
    return next();
  }
  next(getDefaultPathObject());
};

export const canManageUsers = (to, from, next) => {
  if (store.getters.canManageUsers) return next();
  next(getDefaultPathObject());
};

export const canGenerateReports = (to, from, next) => {
  if (store.getters.canGenerateReports) return next();
  next(getDefaultPathObject());
};

export const canManageAllGroups = (to, from, next) => {
  if (store.getters.canManageAllGroups) return next();
  next(getDefaultPathObject());
};

export const canUseSaveStates = (to, from, next) => {
  if (store.getters.canUseSaveStates) return next();
  next(getDefaultPathObject());
};

export const canSelectGame = (to, from, next) => {
  if (store.getters.canSelectGame) return next();
  next(getDefaultPathObject());
};

export const canRestartGame = (to, from, next) => {
  if (store.getters.canRestartGame) return next();
  next(getDefaultPathObject());
};

export const canViewDemo = (to, from, next) => {
  if (store.getters.canViewDemo) return next();
  next(getDefaultPathObject());
};

// TODO: new privilege system will replace this
export const isOwnerOrAdmin = (to, from, next) => {
  if (store.getters.isOwnerOrAdmin) return next();
  next(getDefaultPathObject());
};

// TODO: new privilege system will replace this
export const isOwnerAdminOrProfessor = (to, from, next) => {
  if (store.getters.isOwnerAdminOrProfessor) return next();
  next(getDefaultPathObject());
};

export const isOwnerAdminDeveloperOrProfessor = (to, from, next) => {
  if (store.getters.isOwnerAdminDeveloperOrProfessor) return next();
  next(getDefaultPathObject());
};

export const onFirstNavigationEnter = (route, authCheck) => (to, from, next) => {
  const { params } = to;
  let completeRoute = route;
  Object.keys(params).forEach((param) => {
    const value = params[param];
    completeRoute = completeRoute.replace(`:${param}`, value);
  });

  if (firstNavigation || firstGameNavigation) {
    firstNavigation = false;
    firstGameNavigation = false;
    if (completeRoute === from.path) return next();
    return next(completeRoute);
  }
  if (authCheck) return authCheck(to, from, next);
  next();
};



// WEBPACK FOOTER //
// ./src/router/middleware/middleware.js